<ngx-panel class="marker-set-panel">
	<panel-heading>
		<div class="title ellipsis">
			@if (isLoading) {
				<span class="ficon-spinner ficon-spin"></span>
			} @else {
				<span translate="chart_title-tags"></span>
			}
		</div>

		<ngx-toolbar>
			<ngx-toolbar-button
				class="edit-btn"
				[action]="toolbarActions.EDIT"
				[disabled]="isLoading || isFetchingEditPermissions"
				(clicked)="handleEdit()">
			</ngx-toolbar-button>
			<ngx-toolbar-button
				class="remove-btn"
				[action]="toolbarActions.REMOVE"
				[disabled]="isLoading || isFetchingEditPermissions"
				(clicked)="handleRemove()">
			</ngx-toolbar-button>
		</ngx-toolbar>
	</panel-heading>

	@if (!isLoading) {
		<panel-body>
			<span class="marker-set-name">
				{{ resolvedMarkerSet?.title || ('common_untitled' | translate) }}
			</span>
			<marker-display [markers]="markers"></marker-display>
		</panel-body>
	}
</ngx-panel>
